<template>
  <div>
    <div class="panel panel-default">
      <div class="panel-heading">
        <div class="row">
          <div
            class="col-xs-12 col-sm-2 col-md-2 col-lg-2 text-center"
            style="margin-top: 6px"
          >
            <span class="fa fa-calendar icone_calendario" />
          </div>
          <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
            <p class="data_hora">{{
              formatarData(agendamento.data, 'DD/MM/YYYY')
            }}</p>
            <p class="data_hora">{{ agendamento.hora }}</p>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 text-right">
            <p
              :class="
                'data_hora status_agendamento agendamento-legenda-item--' +
                agendamento.status
              "
              >{{ agendamento.status }}</p
            >
            <p
              :class="
                'statusbloqueioPagamento statusbloqueioPagamento--' +
                agendamento.bloqueadoParaPagamento
              "
              >{{
                statusBloqueioPagamento(agendamento.bloqueadoParaPagamento)
              }}</p
            >
          </div>
        </div>
      </div>
      <div class="panel-body panel_info">
        <table class="table table-striped tabela_info">
          <tbody>
            <tr>
              <td> <strong>Profissional</strong> </td>
              <td> {{ agendamento.profissional.nome }} </td>
            </tr>
            <tr>
              <td> <strong>Unidade</strong> </td>
              <td> {{ agendamento.unidade }} </td>
            </tr>
            <tr>
              <td> <strong>Especialidade</strong> </td>
              <td> {{ agendamento.especialidade }} </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="btn-group btn-group-justified" role="group" aria-label="...">
        <div class="btn-group" role="group">
          <button
            id="botaoBloquear"
            v-tooltip.bottom="'Bloquear Pagamento'"
            data-test-id="button-botaobloquear"
            name="botaBloquear"
            type="button"
            class="btn btn-sm btn-default"
            @click="bloquearPagamento(agendamento)"
          >
            <span class="fa fa-lock" />
          </button>
        </div>
        <div class="btn-group" role="group">
          <button
            id="botaoDesbloquar"
            v-tooltip.bottom="'Desbloquear Pagamento'"
            data-test-id="button-botaodesbloquar"
            name="botaoDesbloquar"
            type="button"
            class="btn btn-sm btn-default"
            @click="desbloquearPagamento(agendamento)"
          >
            <span class="fa fa-unlock" />
          </button>
        </div>
        <div class="btn-group" role="group">
          <button
            id="botaoRemover"
            v-tooltip.bottom="'Remover'"
            data-test-id="button-botaoremover"
            name="botaoRemover"
            type="button"
            class="btn btn-sm btn-default"
            @click="removerAgendamento(agendamento)"
          >
            <span class="fa fa-trash" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as formatadores from '@/utils/formatadores'

export default {
  name: 'GuiaAgendamentosFicha',
  props: {
    agendamento: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...formatadores,
    bloquearPagamento(agendamento) {
      this.$emit('agendamentoBloquearPagamento', agendamento._id)
    },
    desbloquearPagamento(agendamento) {
      this.$emit('agendamentoDesbloquearPagamento', agendamento._id)
    },
    removerAgendamento(agendamento) {
      this.$emit('agendamentoRemover', agendamento._id)
    },
  },
}
</script>
<style scoped>
.data_hora {
  padding: 0;
  margin: 0;
  font-size: 1.1em;
}

.icone_calendario {
  font-size: 2.2em;
}

.status_agendamento {
  font-size: 1.1em;
  font-weight: bold;
  text-transform: uppercase;
}
</style>
